"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var __1 = require("..");
var InputLabel_1 = require("./InputLabel");
var react_2 = require("@emotion/react");
var defaultProps = {
    size: 'fit',
    iconPosition: 'left',
    variant: 'boxed',
};
var getCSSRules = function (_a, styles) {
    var borderRadius = _a.borderRadius, colors = _a.colors;
    return ({
        inputGroup: {
            marginTop: 4,
        },
        inputWrap: {
            display: 'inline-flex',
            flexDirection: 'column',
            position: 'relative',
        },
        inputExtras: {
            color: colors.Grey[500],
            columnGap: 4,
            display: 'grid',
            gridTemplateColumns: '1fr auto',
        },
        description: {
            paddingTop: 4,
        },
        limit: {
            paddingTop: 4,
            textAlign: 'end',
        },
        error: {
            color: colors.Red[600],
        },
        base: {
            fontFamily: 'inherit',
            color: colors.Grey[900],
            width: '100%',
        },
        input: __assign({ padding: '10px 11px 11px', fontSize: 14, border: "1px solid ".concat(colors.Grey[500]), boxSizing: 'border-box', borderRadius: borderRadius.sm, '&::placeholder': {
                color: "".concat(colors.Grey[500]),
            }, '&:focus, &:focus-visible': {
                boxShadow: 'none',
                outline: 'none',
                borderColor: colors.Hannibal[600],
                backgroundColor: colors.Hannibal[100],
            } }, styles),
        valid: {
            borderColor: colors.Green[600],
        },
        hasIcon: {
            paddingLeft: 32,
        },
        stretch: {
            width: '100%',
        },
        icon: {
            position: 'absolute',
            top: 12,
            left: 10,
            pointerEvents: 'none',
            maxWidth: 12,
            maxHeight: 12,
        },
        iconRight: {
            left: 'auto',
            right: 13,
        },
        iconRightInput: {
            paddingLeft: 11,
            paddingRight: 32,
        },
        iconDisabled: {
            opacity: 0.5,
        },
        borderless: {
            fontSize: 30,
            border: 'none',
            padding: 0,
            '&:focus': {
                outline: 'none',
            },
            '&::placeholder': {
                color: "".concat(colors.Grey[400]),
            },
        },
        boxedErrored: {
            borderColor: colors.Red[600],
        },
        borderlessErrored: {
            '&::placeholder': {
                color: "".concat(colors.Red[600]),
            },
        },
        disabled: {
            borderColor: colors.Grey[400],
            backgroundColor: colors.Grey[0],
            color: colors.Grey[400],
            '&::placeholder': {
                color: colors.Grey[400],
            },
        },
    });
};
var InputMessage = function (_a) {
    var error = _a.error, children = _a.children;
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ css: (0, react_2.css)(styles.description, error && styles.error) }, { children: (0, jsx_runtime_1.jsx)(__1.Typography, __assign({ variant: "textSmall" }, { children: children }), void 0) }), void 0));
};
var InputLimit = function (_a) {
    var error = _a.error, value = _a.value, limit = _a.limit;
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ css: (0, react_2.css)(styles.limit, error && styles.error) }, { children: (0, jsx_runtime_1.jsx)(__1.Typography, __assign({ color: value > limit ? 'Red@600' : undefined, variant: "textSmall" }, { children: "".concat(value, " / ").concat(limit) }), void 0) }), void 0));
};
var Input = function (props, ref) {
    var _a;
    var onChange = props.onChange, style = props.style, placeholder = props.placeholder, errorText = props.errorText, size = props.size, error = props.error, icon = props.icon, label = props.label, iconPosition = props.iconPosition, required = props.required, variant = props.variant, component = props.component, description = props.description, id = props.id, disabled = props.disabled, tooltip = props.tooltip, limit = props.limit, rest = __rest(props, ["onChange", "style", "placeholder", "errorText", "size", "error", "icon", "label", "iconPosition", "required", "variant", "component", "description", "id", "disabled", "tooltip", "limit"]);
    var theme = (0, react_2.useTheme)();
    var styles = getCSSRules(theme, style);
    var Tag = component ? component : 'input';
    var length = (_a = props.value) === null || _a === void 0 ? void 0 : _a.length;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ css: (0, react_2.css)(styles.inputGroup, size === 'stretch' && styles.stretch) }, { children: [label && ((0, jsx_runtime_1.jsx)(InputLabel_1.InputLabel, __assign({ tooltip: tooltip, required: required, id: id }, { children: label }), void 0)), (0, jsx_runtime_1.jsxs)("div", __assign({ css: (0, react_2.css)(styles.inputWrap, size === 'stretch' && styles.stretch) }, { children: [(0, jsx_runtime_1.jsx)(Tag, __assign({ disabled: disabled, ref: ref, required: required, placeholder: placeholder, css: (0, react_2.css)(styles.base, variant === 'boxed' && styles.input, variant === 'boxed' && error && styles.boxedErrored, error === false && styles.valid, variant === 'borderless' && styles.borderless, variant === 'borderless' && error && styles.borderlessErrored, !!icon && styles.hasIcon, iconPosition === 'right' && styles.iconRightInput, disabled && styles.disabled), onChange: onChange }, rest), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ css: styles.inputExtras }, { children: [!!errorText && error && ((0, jsx_runtime_1.jsx)(InputMessage, __assign({ error: true }, { children: errorText }), void 0)), !!description && !error && ((0, jsx_runtime_1.jsx)(InputMessage, { children: description }, void 0)), limit && (0, jsx_runtime_1.jsx)(InputLimit, { limit: limit, value: length }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)(react_2.ClassNames, { children: function (_a) {
                            var css = _a.css;
                            return icon && (0, react_1.isValidElement)(icon)
                                ? (0, react_1.cloneElement)(icon, {
                                    className: css(styles.icon, iconPosition === 'right' && styles.iconRight, disabled && styles.iconDisabled),
                                })
                                : icon;
                        } }, void 0)] }), void 0)] }), void 0));
};
var ForwardedInput = (0, react_1.forwardRef)(Input);
ForwardedInput.defaultProps = defaultProps;
var Textarea_1 = require("./Textarea");
Object.defineProperty(exports, "Textarea", { enumerable: true, get: function () { return __importDefault(Textarea_1).default; } });
exports.default = ForwardedInput;
//# sourceMappingURL=index.js.map